module.exports = __webpack_public_path__ + "static/media/ipk2020_better.a58ed4aa.JPG";